module.exports = __webpack_public_path__ + "img/260.4a3ad0db.jpg";